import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  getRequestPaymentCustomersByCountry,
  getRequestPaymentCustomersByCountryFetchFailed,
} from '../../../../data/requestPayment/requestPaymentSelectors'
import { useSelectedClientData } from '../../../clients/clientDetails/data/hooks/useSelectedClientData'
import { ESSENTIALS_ACCESS, getEssentialsAccess } from '../essentialsAccess'

/** Whether the selected client's customer allows Essentials. */
export const useEssentialsAccess = (): ESSENTIALS_ACCESS => {
  // `currentData`, not `data`: RTK Query keeps the previous client's details while the next one loads,
  // which would briefly report that client's access for the newly selected one.
  const { currentData: selectedClientDetails, isFetching } = useSelectedClientData()
  const customersByCountry = useSelector(getRequestPaymentCustomersByCountry)
  const customersByCountryFetchFailed = useSelector(getRequestPaymentCustomersByCountryFetchFailed)

  return useMemo(() => {
    if (!selectedClientDetails) {
      return isFetching ? ESSENTIALS_ACCESS.LOADING : ESSENTIALS_ACCESS.UNRESOLVED
    }
    const { country, employer } = selectedClientDetails
    if (!country) {
      return ESSENTIALS_ACCESS.UNRESOLVED
    }
    const customers = customersByCountry?.[country]
    if (!customers) {
      return customersByCountryFetchFailed?.[country] ? ESSENTIALS_ACCESS.UNRESOLVED : ESSENTIALS_ACCESS.LOADING
    }
    return getEssentialsAccess(customers, employer)
  }, [selectedClientDetails, isFetching, customersByCountry, customersByCountryFetchFailed])
}
